
export default {
	SERVER_BASE: "/pallet_server/",
	API_URL: "https://kalls.se/headless/"
}